import React, { ReactElement } from 'react';

interface Props {
  width?: string;
  height?: string;
  style?: React.CSSProperties;
  viewBox?: string;
}

const ZoomOut = (props: Props): ReactElement => {
  const { width, height, style, viewBox } = props;

  return (
    <svg width={width} height={height} style={style} viewBox={viewBox}>
      <path d="M6.667,0c3.682,0 6.666,2.985 6.666,6.667c0,1.66 -0.607,3.18 -1.611,4.346l4.132,4.133c0.195,0.196 0.195,0.512 0,0.708c-0.19,0.19 -0.496,0.195 -0.692,0.014l-0.016,-0.014l-4.131,-4.133c-1.168,1.005 -2.687,1.612 -4.348,1.612c-3.682,0 -6.667,-2.983 -6.667,-6.666c0,-3.682 2.985,-6.667 6.667,-6.667Zm0,1c-3.13,0 -5.667,2.537 -5.667,5.667c0,3.13 2.537,5.666 5.667,5.666c3.13,0 5.666,-2.537 5.666,-5.666c0,-3.13 -2.537,-5.667 -5.666,-5.667Zm3.247,5.196c0.276,-0.003 0.502,0.218 0.505,0.494c0.004,0.27 -0.206,0.491 -0.473,0.505l-0.02,0.001l-6.478,0.074c-0.277,0.003 -0.503,-0.218 -0.506,-0.494c-0.003,-0.269 0.207,-0.49 0.473,-0.505l0.021,0l6.478,-0.075Z" />
    </svg>
  );
};

ZoomOut.defaultProps = {
  width: '100%',
  height: '100%',
  style: {},
  viewBox: '0 0 16 16',
};

export default ZoomOut;
